import { render, staticRenderFns } from "./BaseOverlay.vue?vue&type=template&id=70f4bcfc&scoped=true&lang=pug&"
import script from "./BaseOverlay.vue?vue&type=script&lang=js&"
export * from "./BaseOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BaseOverlay.vue?vue&type=style&index=0&id=70f4bcfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f4bcfc",
  null
  
)

export default component.exports